<!-- 加工单出仓 -->
<template>
    <div class="warehouseOut" v-loading="dailogLoading">
        <div class="warehouseOut-main">
            <div class="div-table-row table-title">
                <div class="div-table-cell" style="width: 15%">配件名称</div>
                <div class="div-table-cell" style="width: 15%">配件编码</div>
                <div class="div-table-cell" style="width: 10%">待出仓数</div>
                <div class="div-table-cell flex" style="width: 60%">
                    <div class="border-right cell-item" style="width: 30%">仓库</div>
                    <div class="border-right cell-item" style="width: 30%">仓位</div>
                    <div class="border-right cell-item" style="width: 20%">数量</div>
                    <div class="cell-item" style="width: 20%"></div>
                </div>
            </div>
            <div class="table-main">
                <div class="div-table-row" v-for="(item, index) in dataList" :key="item.EntpTempGoodsId">
                    <div class="div-table-cell" style="width: 15%">
                        {{ item.GoodName }}
                    </div>
                    <div class="div-table-cell" style="width: 15%">
                        {{ item.APCode }}
                    </div>
                    <div class="div-table-cell" style="width: 10%">
                        {{ item.Count }}
                    </div>
                    <div class="div-table-cell" style="width: 60%">
                        <div class="cell-line" v-for="(warehouse, i) in item.GoodsLocationList" :key="i.key">
                            <div class="border-right cell-item" style="width: 30%">
                                {{ item.WarehouseName }}
                            </div>
                            <div class="border-right cell-item" style="width: 30%">
                                <el-select
                                    v-model="warehouse.ShelfSpaceId"
                                    :loading="loading"
                                    filterable
                                    clearable
                                    reserve-keyword
                                    @change="positionChange($event, index, i)"
                                    :remote-method="val => remoteMethod(val, warehouse.WarehouseId, warehouse, item.EntpTempGoodsId)"
                                    @visible-change="positionVisibleChange($event, warehouse.WarehouseId, warehouse, item.EntpTempGoodsId)"
                                    size="small"
                                    no-data-text="无存放仓位"
                                >
                                    <el-option
                                        v-for="optionItem in warehouse.ShelfSpacesList"
                                        :label="optionItem.ShelfSpaceCode"
                                        :value="optionItem.ShelfSpaceId"
                                        v-bind:key="optionItem.index"
                                    >
                                        <span style="display: inline-block; width: 150px">{{ optionItem.ShelfSpaceCode }}</span>
                                        <span>库存:{{ optionItem.Count }}</span>
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="border-right cell-item" style="width: 20%">
                                <el-input
                                    size="small"
                                    type="number"
                                    v-model="warehouse.Count"
                                    @blur="checkCount(warehouse.Count, warehouse.CountMax)"
                                    :max="warehouse.CountMax"
                                    :min="0"
                                >
                                </el-input>
                            </div>
                            <div class="cell-item ops-ctn" style="width: 20%; height: 28px; margin-top: 7px">
                                <el-button size="mini" icon="el-icon-minus" @click="delItem(index, i)" v-if="item.Count != 1"></el-button>
                            </div>
                        </div>
                    </div>
                    <el-button size="mini" icon="el-icon-plus" class="add-btn" @click="addItem(index)" v-if="item.Count != 1"></el-button>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <el-button size="small" @click="cancel">取消</el-button>
            <el-button class="btn-primary" size="small" @click="submitData">提交出仓</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['PTOId'],
    components: {},
    data() {
        return {
            loading: false,
            dailogLoading: true,
            searchPositionReq: {
                WarehouseId: '',
                ShelfSpaceCode: '',
                GoodsId: '',
                SortField: 'Count',
                SortType: 'asc',
                MustIn: true,
                Page: 1,
                Limit: 10
            },
            formData: {
                TOId: this.PTOId,
                GoodsList: [
                    {
                        EntpTempGoodsId: '',
                        Count: 0,
                        GoodsLocationList: [
                            {
                                ShelfSpaceId: '',
                                Count: ''
                            }
                        ]
                    }
                ]
            },
            dataList: []
        };
    },
    mounted() {
        this.getPTODetail();
    },
    methods: {
        checkCount(count, max) {
            if (count > max) {
                this.$util.warningMsg('数量不得大于库存数量');
            }
        },
        cancel() {
            this.$emit('closeDialog');
        },
        submitData() {
            let _data = this.dataList;
            for (let i = 0; i < _data.length; i++) {
                let PV = _data[i].Count;
                let EV = 0;
                for (let j = 0; j < _data[i].GoodsLocationList.length; j++) {
                    if (!_data[i].GoodsLocationList[j].ShelfSpaceId) {
                        this.$util.warningMsg('请选择仓位');
                        return;
                    }
                    if (_data[i].GoodsLocationList[j].Count > _data[i].GoodsLocationList[j].CountMax) {
                        this.$util.warningMsg('库存数量不足以出仓');
                        return;
                    }
                    EV += Number(_data[i].GoodsLocationList[j].Count);
                }
                if (PV != EV) {
                    this.$util.warningMsg('出库数量与待出库数量填写不相等');
                    return;
                }
            }
            this.dailogLoading = true;
            this.formData.GoodsList = this.dataList;
            this.$util
                .axiosPost({
                    url: '/api/EntpTransferOrder/SubmitProcessTransOrderOut',
                    data: this.formData
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.$util.successMsg(res.errmsg);
                        this.$emit('closeDialog', true);
                    } else this.$util.errorMsg(res.errmsg);
                })
                .catch(() => {
                    this.dailogLoading = false;
                });
        },
        //仓位下拉框出现/隐藏时触发
        positionVisibleChange(val, warehouseId, warehouse, goodsId) {
            if (!val || !goodsId) return;
            let that = this;
            if (!(warehouse.ShelfSpacesList && warehouse.ShelfSpacesList.length > 0)) {
                that.searchPositionReq.WarehouseId = warehouseId;
                that.searchPositionReq.ShelfSpaceCode = '';
                that.searchPositionReq.GoodsId = goodsId;
                that.searchPositionReq.Page = 1;
                that.searchPosition(that.searchPositionReq).then(resp => {
                    let newArr = [];
                    if (resp.data) newArr = resp.data;
                    that.$set(warehouse, 'ShelfSpacesList', newArr);
                    that.loading = false;
                });
            }
        },
        remoteMethod(val, warehouseId, warehouse, goodsId) {
            if (!val || !warehouseId) return;
            let that = this;
            that.searchPositionReq.WarehouseId = warehouseId;
            that.searchPositionReq.ShelfSpaceCode = val;
            that.searchPositionReq.GoodsId = goodsId;
            that.searchPositionReq.Page = 1;
            that.searchPosition(that.searchPositionReq).then(resp => {
                let newArr = [];
                if (resp.data) newArr = resp.data;
                that.$set(warehouse, 'ShelfSpacesList', newArr);
                that.loading = false;
            });
        },
        searchPosition(req) {
            let that = this;
            if (!req.WarehouseId || that.loading) return;
            that.loading = true;
            return that.$util.getPositionByGId(that.searchPositionReq);
        },
        positionChange(value, index, i) {
            let flag = 0;
            let _data = { ...this.dataList[index] };
            let target = _data.GoodsLocationList[i].ShelfSpacesList ? _data.GoodsLocationList[i].ShelfSpacesList : [];
            for (let j = 0; j < _data.GoodsLocationList.length; j++) {
                if (_data.GoodsLocationList[j].ShelfSpaceId == value) {
                    flag += 1;
                    if (flag >= 2) {
                        _data.GoodsLocationList[j].ShelfSpaceId = '';
                        this.$util.warningMsg('不能选相同仓位');
                        return;
                    }
                }
            }
            this.$set(this.dataList, index, _data);
        },
        delItem(index, i) {
            let _data = { ...this.dataList[index] };
            if (_data.GoodsLocationList.length != 1) {
                _data.GoodsLocationList.splice(i, 1);
            }
            this.$set(this.dataList, index, _data);
        },
        addItem(index) {
            let _target = this.dataList[index].GoodsLocationList;
            let usedCount = 0; //已选数量
            for (let i = 0; i < _target.length; i++) {
                if (!_target[i].ShelfSpaceId) {
                    this.$util.warningMsg('请选择仓位');
                    return;
                }
                if (!_target[i].Count || !_target[i].Count < 0) {
                    this.$util.warningMsg('请填写正确的数量');
                    return;
                }
                usedCount += Number(_target[i].Count);
            }
            let goods = { ...this.dataList[index] };
            //当前商品可出库数量
            let canInCount = Number(goods.Count);
            //剩余数量
            let surplus = canInCount - usedCount;
            goods.GoodsLocationList.push({
                WarehouseName: goods.WarehouseName,
                WarehouseId: goods.WarehouseId,
                ShelfSpaceCode: '',
                ShelfSpaceId: '',
                Count: surplus > 0 ? surplus : 0,
                CountMax: goods.Count,
                ShelfSpacesList: [...goods.GoodsLocationList[goods.GoodsLocationList.length - 1].ShelfSpacesList]
            });
            this.$set(this.dataList, index, goods);
        },
        getPTODetail() {
            this.$util
                .axiosGet({
                    url: '/api/EntpTransferOrder/GetProcessOutContainWH',
                    data: {
                        PTOId: this.PTOId
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    let spaceItem = {
                        WarehouseName: '',
                        WarehouseId: '',
                        ShelfSpaceCode: '',
                        ShelfSpaceId: '',
                        Count: '',
                        CountMax: 999,
                        ShelfSpacesList: []
                    };
                    let _APList = [];
                    for (let i = 0; i < data.DetailList.length; i++) {
                        spaceItem.Count = data.DetailList[i].Count;
                        spaceItem.CountMax = data.DetailList[i].Count;
                        spaceItem.WarehouseId = data.DetailList[i].WarehouseId;
                        spaceItem.WarehouseName = data.DetailList[i].WarehouseName;
                        data.DetailList[i].GoodsLocationList = [{ ...spaceItem }];
                        _APList.push(data.DetailList[i]);
                    }
                    this.dataList = _APList;
                    this.dailogLoading = false;
                });
        }
    }
};
</script>
<style lang="less" scoped>
.add-btn {
    position: absolute;
    right: 10px;
    bottom: 6px;
}
.ops-ctn {
    text-align: left !important;
}
.dialog-footer {
    text-align: right;
    margin-top: 20px;
}
.warehouseOut-main {
    padding-top: 20px;
}
.table-title {
    .cell-item {
        width: 33.33%;
    }
    .div-table-cell {
        text-align: center;
        height: 30px;
        line-height: 30px;
    }
}
.div-table-row {
    position: relative;
    overflow: visible;
}
.table-main {
    .div-table-cell {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
    .cell-line {
        display: flex;
        width: 100%;
    }
    .cell-item {
        padding: 0 10px;
        width: 33%;
        width: inherit;
        text-align: center;
        height: 40px;
        line-height: 40px;
    }
}
</style>
